export const sources = {
	avif: "__VITE_ASSET__DyaxQXH8__ 201w",
	webp: "__VITE_ASSET__DRVOeTj1__ 201w"
};
export const img = {
	src: "__VITE_ASSET__B_772nwn__",
	w: 201,
	h: 245
};
export default {
	sources: sources,
	img: img
};
